import { use } from 'react'
import { useProducts } from '@/lib/polar/products-provider'
import type { Entitlement } from '@/lib/polar/types'

export function useProduct(
  entitlement: Entitlement | undefined,
  recurringInterval: 'month' | 'year' | undefined,
) {
  const { productsPromise } = useProducts()
  const products = use(productsPromise)

  if (!entitlement || !recurringInterval) return null

  const product = products.find((product) => {
    if (product.isArchived) return false
    if (product.recurringInterval !== recurringInterval) return false
    if (product.metadata.entitlement !== entitlement) return false
    return true
  })

  return product ?? null
}
